var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpacesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Spaces_Icon",
    "data-name": "Spaces Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1963",
    "data-name": "Rectangle 1963",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4204",
    "data-name": "Group 4204",
    transform: "translate(2.935 2.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4205",
    "data-name": "Group 4205",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6010",
    "data-name": "Path 6010",
    d: "M9.648,12.558a6.279,6.279,0,1,1,6.279-6.279,6.279,6.279,0,0,1-6.279,6.279m0-11.481a5.2,5.2,0,1,0,5.2,5.2,5.2,5.2,0,0,0-5.2-5.2",
    transform: "translate(-0.677 0)",
    fill: "#525252",
    stroke: "#525252",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6011",
    "data-name": "Path 6011",
    d: "M.536,23.345a.557.557,0,0,1-.284-.082.543.543,0,0,1-.172-.743l1.905-3.05a3.2,3.2,0,0,1,2.727-1.506H13.28A3.228,3.228,0,0,1,15.953,19.4l2.074,3.114a.538.538,0,1,1-.873.631.3.3,0,0,1-.021-.031L15.057,20a2.154,2.154,0,0,0-1.794-.951H4.716a2.12,2.12,0,0,0-1.793,1L1.017,23.1a.544.544,0,0,1-.481.248",
    transform: "translate(0 -3.608)",
    fill: "#525252",
    stroke: "#525252",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpacesIcon);
export default __webpack_public_path__ + "static/media/spaces_icon.e78ff79cd9ede3304c05005061093cf6.svg";
export { ForwardRef as ReactComponent };